import {current} from 'services/menu'
import {treeForEach, findInnerChild, isUrl} from 'utils'
import createModel from 'utils/model'
import {parseData} from 'layouts/auth-layout/components/sider-menu'

export default createModel({
    namespace: 'menu',

    state: {
        tree: [],
        flatTree: [],
        homePage: '',
        checkFlatTree: [],
        siderMenuMap: {},
    },

    effects: {
        *current(_, {call, put, select}) {
            const {data} = yield call(current)
            const flatTree = []
            const checkFlatTree = []

            const {accessToken} = yield select(({base}) => ({
                accessToken: base.accessToken,
            }))

            treeForEach(data, (item) => {
                if (isUrl(item.url)) {
                    let externalUrl = item.url
                    const urlObj = new URL(item.url)
                    if (Number(urlObj.searchParams.get('hz_token')) === 1) {
                        externalUrl = `${urlObj.origin}${urlObj.pathname}?hz_token=${accessToken}`
                    }
                    item.externalUrl = externalUrl
                    item.isExternal = true
                } else {
                    checkFlatTree.push(item)
                }

                flatTree.push(item)
            })

            const siderMenuMap = {}

            data.forEach((item) => {
                const flatMenuData = []
                const menuData = parseData({data: item, flatData: flatMenuData})
                siderMenuMap[item?.slug] = {
                    menuData,
                    flatMenuData,
                }
            })

            yield put({
                type: 'immerSet',
                payload: {
                    siderMenuMap,
                    tree: data,
                    flatTree,
                    checkFlatTree,
                    homePage: findInnerChild(data[0]),
                },
            })
        },
    },
})
